
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import {
  FiGrid,
  FiSend,
  FiDollarSign,
  FiUsers,
  FiTrendingUp,
  FiCreditCard,
  FiDownload,
  FiSettings,
  FiUserPlus,
  FiChevronDown,
  FiLayers,
  FiLogOut,
  FiX
} from "react-icons/fi";

export default function SideNav({ isOpen, onClose, isCollapsed }) {
  const [tooltip, setTooltip] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  const toggleSubmenu = (label) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [label]: !prev[label]
    }));
  };

  const groups = [
    {
      items: [
        {
          label: "Home",
          path: "/dashboard",
          icon: FiGrid,
          end: true
        },

        {
          label: "Fund Transfer",
          icon: FiSend,
          submenu: [
            {
              label: "Transfer Fund",
              path: "/dashboard/transfer-fund"
            },
            {
              label: "Transfer List",
              path: "/dashboard/transfer-list"
            }
          ]
        },

        {
          label: "Make Investment",
          icon: FiTrendingUp,
          submenu: [
            {
              label: "Package Request",
              path: "/dashboard/make-investment"
            },
            {
              label: "Self Investment",
              path: "/dashboard/self-investment"
            }
          ]
        },



        {
          label: "My Network",
          icon: FiUsers,
          submenu: [
            {
              label: "Direct Referrals",
              path: "direct-referrals"
            },
            {
              label: "Levl 2",
              path: "/dashboard/level2"
            },
            {
              label: "Level 3",
              path: "/dashboard/level3"
            },
            {
              label: "My Team",
              path: "my-team"
            },
          ]
        },


        {
          label: "Income Report",
          icon: FiDollarSign,
          submenu: [
            {
              label: "Auto Pool Income",
              path: "/dashboard/autopool-income"
            },
            {
              label: "Referral Income",
              path: "/dashboard/referral-income"
            },
            {
              label: "Support Income",
              path: "/dashboard/support-income"
            }
          ]
        },

        {
          label: "Withdrawal",
          icon: FiDownload,
          submenu: [
            {
              label: "Fund Withdrawal",
              path: "/dashboard/fund-withdrawal"
            },
            {
              label: "Withdrawal Report",
              path: "/dashboard/withdrawal-report"
            }
          ]
        },


        {
          label: "Settings",
          icon: FiSettings,
          submenu: [
            {
              label: "Edit Profile",
              path: "/dashboard/edit-profile"
            },
            {
              label: "Change Password",
              path: "/dashboard/change-password"
            }
          ]
        },

        {
          label: "Invite",
          path: "/dashboard/invite",
          icon: FiUserPlus
        }
      ]
    }
  ];
  const closeMobile = () => {
    if (window.innerWidth < 992) onClose();
  };

  const showTooltip = (e, label) => {
    if (!isCollapsed || window.innerWidth < 992) return;

    const rect = e.currentTarget.getBoundingClientRect();

    setTooltip({
      label,
      top: rect.top + rect.height / 2,
      left: rect.right + 14
    });
  };

  const hideTooltip = () => setTooltip(null);

  // Open confirmation popup
  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  // Confirm logout
  const confirmLogout = () => {
    localStorage.clear();
    setShowLogoutModal(false);
    navigate("/");
  };

  // Cancel logout
  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      {isOpen && (
        <div
          className="gi-sidebar-backdrop"
          onClick={onClose}
        />
      )}

      <aside
        className={`gi-sidebar ${isOpen ? "gi-sidebar-open" : ""
          } ${isCollapsed ? "gi-sidebar-collapsed" : ""
          }`}
      >
        <div className="gi-sidebar-head">
          <NavLink
            to="/dashboard"
            className="gi-sidebar-logo"
            onClick={closeMobile}
          >
            <span className="gi-sidebar-logo-mark">
              <img src={logo} alt="Global Innovation" style={{ width: "30px", height: "30px" }} />
            </span>

            <span>
              <strong>Global Inavation</strong>

            </span>
          </NavLink>

          <button
            type="button"
            className="gi-sidebar-mobile-close"
            onClick={onClose}
            aria-label="Close navigation"
          >
            <FiX />
          </button>
        </div>

        <nav
          className="gi-sidebar-nav"
          aria-label="Dashboard navigation"
        >
          {groups.map((group) => (
            <div
              className="gi-nav-group"
              key={group.title}
            >
              <div className="gi-nav-group-title">
                {group.title}
              </div>

              {group.items.map((item) => {
                const Icon = item.icon;

                const hasSubmenu =
                  item.submenu &&
                  item.submenu.length > 0;

                const isSubmenuActive =
                  hasSubmenu &&
                  item.submenu.some(
                    (subItem) =>
                      location.pathname === subItem.path
                  );

                const isOpen =
                  openSubmenus[item.label] ||
                  isSubmenuActive;

                /* ================= SUBMENU ================= */

                if (hasSubmenu) {
                  return (
                    <div
                      className="gi-nav-submenu-wrapper"
                      key={item.label}
                    >
                      <button
                        type="button"
                        className={`gi-nav-link gi-nav-submenu-toggle ${isSubmenuActive
                          ? "gi-nav-link-active"
                          : ""
                          }`}
                        onClick={() =>
                          toggleSubmenu(item.label)
                        }
                        onMouseEnter={(e) =>
                          showTooltip(e, item.label)
                        }
                        onMouseLeave={hideTooltip}
                      >
                        <span className="gi-nav-icon">
                          <Icon />
                        </span>

                        <span className="gi-nav-label">
                          {item.label}
                        </span>

                        <FiChevronDown
                          className={`gi-nav-submenu-arrow ${isOpen
                            ? "gi-nav-submenu-arrow-open"
                            : ""
                            }`}
                        />
                      </button>

                      <div
                        className={`gi-nav-submenu ${isOpen
                          ? "gi-nav-submenu-open"
                          : ""
                          }`}
                      >
                        {item.submenu.map(
                          (subItem) => (
                            <NavLink
                              key={subItem.path}
                              to={subItem.path}
                              onClick={closeMobile}
                              className={({ isActive }) =>
                                `gi-nav-submenu-link ${isActive
                                  ? "gi-nav-submenu-link-active"
                                  : ""
                                }`
                              }
                            >
                              <span className="gi-nav-submenu-dot"></span>

                              <span>
                                {subItem.label}
                              </span>
                            </NavLink>
                          )
                        )}
                      </div>
                    </div>
                  );
                }
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    end={item.end}
                    onClick={closeMobile}
                    onMouseEnter={(e) =>
                      showTooltip(e, item.label)
                    }
                    onMouseLeave={hideTooltip}
                    className={({ isActive }) =>
                      `gi-nav-link ${isActive
                        ? "gi-nav-link-active"
                        : ""
                      }`
                    }
                  >
                    <span className="gi-nav-icon">
                      <Icon />
                    </span>

                    <span className="gi-nav-label">
                      {item.label}
                    </span>

                    {item.badge && (
                      <span className="gi-nav-badge">
                        {item.badge}
                      </span>
                    )}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>

        <div className="gi-sidebar-bottom">
          <div className="gi-sidebar-mini-card">
            <div className="gi-mini-icon">
              <FiLayers />
            </div>

            <div>
              <strong>Support</strong>

            </div>
          </div>

          <button
            type="button"
            className="gi-sidebar-logout"
            onClick={handleLogout}
          >
            <FiLogOut />
            <span>Sign out</span>
          </button>
        </div>
      </aside>

      {createPortal(
        <div
          className={`gi-nav-tooltip-portal ${tooltip
            ? "gi-nav-tooltip-visible"
            : ""
            }`}
          style={
            tooltip
              ? {
                top: tooltip.top,
                left: tooltip.left
              }
              : undefined
          }
        >
          {tooltip?.label}
        </div>,
        document.body
      )}

      {showLogoutModal &&
        createPortal(
          <div
            className="gi-logout-overlay"
            onClick={cancelLogout}
          >
            <div
              className="gi-logout-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="gi-logout-close"
                onClick={cancelLogout}
                aria-label="Close"
              >
                <FiX />
              </button>

              <div className="gi-logout-icon">
                <FiLogOut />
              </div>

              <h3>Sign out?</h3>

              <p>
                Are you sure you want to sign out of
                your account?
              </p>

              <div className="gi-logout-actions">
                <button
                  type="button"
                  className="gi-logout-cancel"
                  onClick={cancelLogout}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="gi-logout-confirm"
                  onClick={confirmLogout}
                >
                  <FiLogOut />
                  Sign out
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};



